export enum ListStyleEnum {
  Default = 'default',
  Shadowed = 'shadowed',
}
